import { makeStyles } from '@material-ui/core/styles';

export default () => {
    let useStyles = makeStyles(theme => {
        return {
            main: {
                display: 'grid',
                gridTemplateRows: 'auto 1fr',
                gridTemplateColumns: '1fr',
                width: '100%',
                fontSize:"13px",
                color:"#112B42"
            },
            header: {
                display: 'flex',
                alignItems: 'center',
                height: 78,
                padding: '0 20px',
                justifyContent: 'space-between',
                borderBottom: '1px solid #CCCCCC'
            },
            alignCenter: {
                display: 'flex',
                alignItems: 'center'
            },
            
            leftScreen: {
                height: 'calc(100vh - 105px)',
                padding: '15px',
                overflowY: 'auto',
                borderRight: '1px solid #cccccc',
            },
            card: {
                // minWidth: 275,
                width: '100%',
                height: 'auto',
                
            },
            bullet: {
                display: 'inline-block',
                margin: '0 2px',
                transform: 'scale(0.8)',
            },
            title: {
                fontSize: 14,
                fontWeight: 'bold',
                color: '#000'
            },
            pos: {
                marginBottom: 12,
            },

            accountDetails: {
                margin: '20px 0'
            },

            boldGrey: {
                color: '#818390',
                fontWeight: 'bold'
            },

            green: {
                color: '#41A33F',
                fontWeight: 500
            },

            leftTitle: {
                color: '#0B80EC'
            },

            taxDetails: {
                margin: '20px 0'
            },

            addressDetails: {
                margin: '20px 0'
            },


            rightScreen: {
                padding: '20px 20px 0 20px',
                width:"100%"
                // display: 'grid',
               
            },

            transactionDetailsTop: {
                display: 'grid',
                gridTemplateRows: '1fr 3fr'
            },

            transactionDetailsHeader: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            },

            transactionDetailsAmounts: {
                display: 'flex',
                justifyContent: 'space-between',
                padding: '20px 0 10px 20px',
                backgroundColor: '#EFF7FE',
                marginTop: 20,
                marginBottom: 30,
                borderRadius: 8,
                '& > div': {
                    display: 'flex',
                    flexDirection: 'column',
                    
                    '& > span:nth-child(1)': {
                        color: '#243768',
                        marginBottom: 5
                    },
                    '& > span:nth-child(2)': {
                        color: '#45A641',
                        fontWeight: 'bold'
                    }
                }
            },

            transactionDetailsBottom: {
                height: 'calc(100vh - 270px)',
                overflowY: 'auto',
                paddingRight: 15
            },

            transactionDetailsControls: {
                display: 'flex',
                color: '#96A9C3'
            },

            darkTableCell: {
                color: '#44424C !important',
                textAlign: 'center'
            },

            drop:{
                background:"#ffffff",
                width:"140px",
                height:"35px",
                paddingLeft:"10px",
                paddingRight:"10px",
                marginLeft:"8px",
                borderRadius:"6px",
                marginTop:"3px",
                color:"#112B42",
                fontSize: 14,
                boxShadow: '0 5px 4px #d8d8d8'
            },
        }
    })

    return useStyles;
}